import * as React from "react";
import { SplitterElementPosition, Splitter } from "azure-devops-ui/Splitter";

export default class SplitterExample extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }

    public render() {
        const containerStyle = { height: "500px", width: "600px", display: "flex" };
        return (
            <div style={containerStyle}>
                <Splitter
                    fixedElement={SplitterElementPosition.Near}
                    splitterDirection={this.props.splitterDirection}
                    initialFixedSize={300}
                    minFixedSize={100}
                    nearElementClassName="v-scroll-auto custom-scrollbar"
                    farElementClassName="v-scroll-auto custom-scrollbar"
                    onRenderNearElement={this._renderNearContent}
                    onRenderFarElement={this._renderFarContent}
                />
            </div>
        );
    }

    private _renderNearContent(): JSX.Element {
        return (
            <div style={{ padding: "16px" }}>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia
                deserunt mollit anim id est laborum.
            </div>
        );
    }

    private _renderFarContent(): JSX.Element {
        return (
            <div style={{ padding: "16px" }}>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia
                deserunt mollit anim id est laborum.
            </div>
        );
    }
}
